import { Button } from "@/components/ui/button";
import moment from "moment";

export function PartRepairableDetailHandler({
  currentExport,
  data,
  dataSave,
  exportToExcel,
}) {
  if (currentExport == "part repairable") {
    const exportData = dataSave.part_repairables
      .filter((obj) => {
        if (data.customer_id && obj.service_order_ticket.customer_id) {
          return data.customer_id == obj.service_order_ticket.customer_id;
        } else {
          return true;
        }
      })
      .filter((obj) => {
        if (data.location_id && data.location_type) {
          return (
            obj.location_id == data.location_id &&
            obj.location_type == data.location_type
          );
        } else {
          return true;
        }
      })
      .map((obj) => {
        return {
          "Part Name": obj.part_details.name,
          "Part Number": obj.part_details.part_number,
          "Part SN": obj.part_sn,
          Condition: obj.status,
          "Location Base": obj.location_type,
          "Location Name": obj.locations.name,
        };
      });
    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `part_repairable_detail_${moment().format("hhmm_DDMMYYYY")}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
